import { jsx as _jsx } from "react/jsx-runtime";
import { Prompt } from '@coveord/plasma-mantine';
import { Locales } from '../../../../strings/Locales.js';
export var DeleteBulkResourcesPromptCancelButton = function DeleteBulkResourcesPromptCancelButton(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ _jsx(Prompt.CancelButton, {
        onClick: onClick,
        children: Locales.format('DeleteBulkResourcesPrompt.footer.button.cancel')
    });
};

//# sourceMappingURL=DeleteBulkResourcesPromptCancelButton.js.map